import React, { useContext, useEffect } from 'react';

//components
import WidgetButton from './WidgetButton/WidgetButton';

//enums
import { WidgetType } from  '@/interfaces/widgetPanel';

//context
import {ListContext} from '@/context/ListContext';



const ListWidget = () => {
    
    const {listId, appGuid, isMainMenu} = useContext(ListContext)

    return (
        <div className="widget-panel-item">
            <WidgetButton type={WidgetType.LIST} href={`/a/${appGuid}/Content?parentId=${listId}&contentType=List&position=${isMainMenu ? 'end' : 'start'}`} />
        </div>
    )
}
export default ListWidget